let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cJJJA")).then(() => parcelRequire('dILzZ'));